import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function RebelNotes() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/resources").then(r => setItems(r.data)); }, []);
  return (
    <div data-testid="rebel-notes-page">
      <section className="py-32 text-center">
        <div className="max-w-4xl mx-auto px-6 sm:px-10">
          <div className="eyebrow-lg">Rebel Notes</div>
          <h1 className="mt-10 h-editorial text-5xl sm:text-8xl">The <span className="italic-serif text-[#D4AF37]">private</span> library.</h1>
          <p className="mt-12 max-w-xl mx-auto text-zinc-400">Thoughtful writing on desire, confidence, sensuality, pleasure, communication, boundaries, kink, curiosity, connection, body awareness, and sexual self-discovery.</p>
        </div>
      </section>

      <section className="hairline-t py-16">
        <div className="max-w-4xl mx-auto px-6 sm:px-10">
          {items.map((r, i) => (
            <article key={r.resource_id} data-testid={`note-${r.resource_id}`} className="py-10 border-b border-white/10 group cursor-pointer">
              <div className="grid grid-cols-1 sm:grid-cols-12 gap-6 items-start">
                <div className="sm:col-span-2 eyebrow-lg text-zinc-500">№ {String(i + 1).padStart(2, "0")}</div>
                <div className="sm:col-span-8">
                  <h3 className="h-editorial text-3xl sm:text-4xl group-hover:text-[#D4AF37] transition-colors">{r.title}</h3>
                  <p className="mt-4 text-zinc-400 leading-relaxed">{r.excerpt}</p>
                </div>
                <div className="sm:col-span-2 sm:text-right">
                  <div className="eyebrow-lg text-zinc-500">{r.reading_time}</div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
